// Detect whether the cursor sits at the routine-reference slot of a
// statement-leading `CALL <ident>` (MySQL / Postgres). The statement's
// position classifier currently labels this as `'from'` because grammatically
// `CALL <ident>` looks like a table target — but the user expects stored
// procedures, not tables, to surface here. Resolvers consult this helper to
// route the slot to `emitRoutines` instead of `emitTablesAndDatabases`.
//
// Returns true iff, after stripping line/block comments from the slice
// `[statementStart, offset)`, the slice matches `CALL <partial-ident-prefix>`
// (no opening paren reached yet — the cursor is still typing the routine
// name).
export function isAtCallStmtRoutineRef(
  text: string,
  statementStart: number,
  offset: number,
): boolean {
  if (offset < statementStart) return false;
  const raw = text.slice(statementStart, offset);
  const stripped = raw
    .replace(/\/\*[\s\S]*?\*\//g, ' ')
    .replace(/--[^\n]*/g, ' ');
  return /^\s*CALL\s+[\w$.]*$/i.test(stripped);
}
